import {
    Grid,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormLabel,
    Card,
    CardContent,
    Typography,
    Divider,
    CardMedia,
    IconButton,
    Dialog
} from "@mui/material";
import { useEffect, useState } from "react";
import "../Common/css/styles.css";
import "../Common/css/user.css";
import { deleteRecording, getRecording } from "src/Services/zoom_api";
import ReactPlayer from "react-player";
import { Delete, Info, InfoOutlined } from "@mui/icons-material";
import { getInstructorById } from "src/Services/instructor_api";
import Dialogbox from "src/Components/Dialogbox";
import CustomAlert from "src/Components/Alerts";
import Spinner from "src/Components/Spinner";

export default function AdminCourses() {

    const options = [
        {
            value: "1",
            label: "Fast track A/L",
            streams: [
                {
                    id: "1", stream: "Arts Stream", subjects: [
                        { subId: "1", subject: "Econ" },
                        { subId: "2", subject: "Media" },
                        { subId: "3", subject: "ICT" },
                        { subId: "4", subject: "Sinhala" },
                        { subId: "5", subject: "Political Science" }
                    ]
                },
                {
                    id: "2", stream: "Commerce Stream", subjects: [
                        { subId: "6", subject: "Business Studies" },
                        { subId: "7", subject: "Accounts" },
                        { subId: "8", subject: "Econ" },
                        { subId: "9", subject: "ICT" }
                    ]
                },
                {
                    id: "3", stream: "Technology Stream", subjects: [
                        { subId: "10", subject: "Engineering Technology" },
                        { subId: "11", subject: "Science For Technology" },
                        { subId: "12", subject: "ICT" }
                    ]
                },
                { id: "4", stream: "General English in A/L", subjects: [] }
            ]
        },
        {
            value: "2",
            label: "Diploma",
            streams: [
                { id: "5", stream: "Diploma in Marketing", subjects: [] },
                { id: "6", stream: "Diploma in HRM", subjects: [] },
                { id: "7", stream: "Diploma in English", subjects: [] },
                { id: "8", stream: "Diploma in ICT", subjects: [] }
            ]
        },
        {
            value: "3",
            label: "Certificate course",
            streams: [
                { id: "9", stream: "Certificate course in Marketing", subjects: [] },
                { id: "10", stream: "Certificate course in HRM", subjects: [] },
                { id: "11", stream: "Certificate course in English", subjects: [] },
                { id: "12", stream: "Certificate course in ICT", subjects: [] }
            ]
        }
    ];

    const videoLessons = [
        { id: 1, title: "Video Lesson - Basics of Economics" },
        { id: 2, title: "Video Lesson - Supply & Demand" },
    ];

    const [selectedProgramme, setSelectedProgramme] = useState<string | null>(null);
    const [selectedStream, setSelectedStream] = useState<string | null>(null);
    const [selectedSubject, setSelectedSubject] = useState<string | null>(null);
    const [recordings, setRecordings] = useState<any[]>([]);
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [selectedVideoLesson, setSelectedVideoLesson] = useState<any | null>(null);
    const [instructorName, setInstructorName] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertDescription, setAlertDescription] = useState("");
    const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success");

    const token = sessionStorage.getItem("token") || "";

    const programme = options.find(p => p.value === selectedProgramme);
    const stream = programme?.streams.find(s => s.id === selectedStream);
    const subject = stream?.subjects.find(s => s.subId === selectedSubject);

    //console.log("Programme Name:", programme?.label || null);
    //console.log("Stream Name:", stream?.stream || null);
    //console.log("Subject Name:", subject?.subject || null);

    // Reusable Radio Style
    const radioStyle = {
        color: "black",
        "&.Mui-checked": {
            color: "#d9cb06ff",
        },
    };

    const showAlert = (description: string, type: "success" | "error" | "warning") => {
        setAlertDescription(description);
        setAlertType(type);
        setAlertOpen(true);
    };

    const handleGetRecordings = async () => {
        try {
            const res = await getRecording(programme?.label ?? "", stream?.stream ?? "", subject?.subject ?? "", token);
            setRecordings(res.data);
        } catch (error) {
            console.error("Error fetching recordings:", error);
            setRecordings([]);
        }
    }

    const handleGetInstructorName = async (instructorId: string) => {

        try {
            const res = await getInstructorById(instructorId, token);
            setInstructorName(res.name);
        } catch (error) {
            console.error("Error fetching instructor name:", error);
            setInstructorName("Unknown Instructor");
        }
    }

    const handleDelete = async (Id: string) => {
        setIsLoading(true);
        try {
            await deleteRecording(programme?.label ?? "", stream?.stream ?? "", subject?.subject ?? "", Id, selectedVideoLesson.instructorId, token);
            showAlert("Video lesson deleted successfully", "success");
            handleGetRecordings();
            setIsOpen(false);
        } catch (error) {
            showAlert("Error deleting video lesson", "error");
            setIsOpen(false);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        handleGetRecordings();
    }, [selectedProgramme, selectedStream, selectedSubject]);

    return (
        <div className="comman-outer">
            <Dialogbox
                open={isOpen}
                title="Delete Video Lesson"
                content="Are you sure you want to delete this video lesson?"
                agreeButtonText="Delete"
                disagreeButtonText="Cancel"
                onAgree={() => handleDelete(selectedVideoLesson.id)}
                onDisagree={() => setIsOpen(false)}
                onClose={() => setIsOpen(false)}
            />
            <CustomAlert
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
                description={alertDescription}
                type={alertType}
                timeout={3000}
            />
            <Spinner isLoading={isLoading} />
            <div className="comman-header-outer">
                <span className="stream-title-text">Courses</span>
            </div>

            {/* Programmes */}
            <div style={{ padding: "20px" }}>
                <FormLabel style={{ color: "black", fontWeight: 600 }}>Programmes</FormLabel>

                <RadioGroup
                    style={{ display: "flex", flexDirection: "row", gap: "20px", flexWrap: "wrap" }}
                    value={selectedProgramme || ""}
                    onChange={(e) => {
                        setSelectedProgramme(e.target.value);
                        setSelectedStream(null);
                        setSelectedSubject(null);
                    }}
                >
                    {options.map((item) => (
                        <FormControlLabel
                            key={item.value}
                            value={item.value}
                            control={<Radio sx={radioStyle} />}
                            label={item.label}
                            style={{ color: "black" }}
                        />
                    ))}
                </RadioGroup>
            </div>

            {/* Streams */}
            {programme && (
                <div style={{ padding: "20px" }}>
                    <FormLabel style={{ color: "black", fontWeight: 600 }}>Streams</FormLabel>

                    <RadioGroup
                        style={{ display: "flex", flexDirection: "row", gap: "20px", flexWrap: "wrap" }}
                        value={selectedStream || ""}
                        onChange={(e) => {
                            setSelectedStream(e.target.value);
                            setSelectedSubject(null);
                        }}
                    >
                        {programme.streams.map((st) => (
                            <FormControlLabel
                                key={st.id}
                                value={st.id}
                                control={<Radio sx={radioStyle} />}
                                label={st.stream}
                                style={{ color: "black" }}
                            />
                        ))}
                    </RadioGroup>
                </div>
            )}

            {/* Subjects */}
            {stream && (
                <div style={{ padding: "20px" }}>
                    <FormLabel style={{ color: "black", fontWeight: 600 }}>Subjects</FormLabel>

                    <RadioGroup
                        style={{ display: "flex", flexDirection: "row", gap: "20px", flexWrap: "wrap" }}
                        value={selectedSubject || ""}
                        onChange={(e) => setSelectedSubject(e.target.value)}
                    >
                        {stream.subjects.map((sub) => (
                            <FormControlLabel
                                key={sub.subId}
                                value={sub.subId}
                                control={<Radio sx={radioStyle} />}
                                label={sub.subject}
                                style={{ color: "black" }}
                            />
                        ))}
                    </RadioGroup>
                </div>
            )}

            <Divider style={{ margin: "20px 0 0 0", borderColor: "gray" }} />

            {/* Final Node: Learning Materials + Video Lessons */}
            {(recordings && recordings.length > 0) && (
                <div style={{ padding: "20px" }}>

                    {/* Video Lessons */}
                    <Typography variant="h6" style={{ marginTop: "30px", marginBottom: "10px", fontWeight: 600, color: "black" }}>
                        Video Lessons
                    </Typography>
                    {/* add delete button */}
                    <Grid container spacing={2}>
                        {recordings.map((video) => (
                            <Grid item xs={12} sm={6} md={4} key={video.id}>
                                <ReactPlayer
                                    url={video.recordLink}
                                    controls
                                    width="100%"
                                    height="240px"
                                />
                                <div style={{ backgroundColor: "#f5f5f5", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
                                    <Typography variant="body2" style={{ marginTop: "0px", color: "black" }}>
                                        {video.title.length > 50 ? video.title.substring(0, 50) + "..." : video.title}
                                    </Typography>
                                    <div>
                                        <IconButton onClick={() => {
                                            handleGetInstructorName(video.instructorId);
                                            setSelectedVideoLesson(video);
                                            setViewDialogOpen(true);
                                        }}>
                                            <InfoOutlined style={{ color: "black" }} />
                                        </IconButton>
                                        <IconButton onClick={() => {
                                            setSelectedVideoLesson(video);
                                            setIsOpen(true);
                                        }}>
                                            <Delete style={{ color: "red" }} />
                                        </IconButton>
                                    </div>

                                </div>

                            </Grid>
                        ))}
                    </Grid>
                </div>
            )}

            <Dialog
                open={viewDialogOpen}
                onClose={() => setViewDialogOpen(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: { backgroundColor: "#c6c2c2e3", color: "white", paddingBottom: 2, borderRadius: 2, boxShadow: 24, border: "1px solid #ffffffff" },
                }}
            >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "1px solid #555", backgroundColor: "#393939", padding: "25px 16px" }}>
                    <h3>Video Lesson Details</h3>
                </div>

                <Grid container spacing={2} style={{ padding: "25px 16px", color: "white" }} className="form-grid">
                    <Grid item xs={12}>
                        <strong>Title:</strong> {selectedVideoLesson?.title}
                    </Grid>
                    <Grid item xs={12}>
                        <strong>Created By:</strong> {instructorName}
                    </Grid>
                    <Grid item xs={12}>
                        <strong>Status:</strong> {selectedVideoLesson?.activeStatus ? "Active" : "Inactive"}
                    </Grid>
                    <Grid item xs={12}>
                        <strong>Created At:</strong> {selectedVideoLesson?.createdTime.split("T")[0]} {selectedVideoLesson?.createdTime.split("T")[1].split(".")[0]}
                    </Grid>
                </Grid>
            </Dialog>
        </div>
    );
}
